import { createAction } from "@ngrx/store";

export const loadDevices = createAction("[AccountDevice] Load Devices");
